import { render, staticRenderFns } from "./NewProperty.vue?vue&type=template&id=6a90dcc3&scoped=true&"
import script from "./NewProperty.vue?vue&type=script&lang=js&"
export * from "./NewProperty.vue?vue&type=script&lang=js&"
import style0 from "./NewProperty.vue?vue&type=style&index=0&id=6a90dcc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90dcc3",
  null
  
)

export default component.exports